import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function ErpCrm() {
  return <DetailPage type="service" id="erp-crm" />;
}
